import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'Index',
    component: lazyLoad("Index")
  },
  {
    path: '/casting',
    name: 'Casting',
    component: lazyLoad("Casting")
  },
  {
    path: '/submit',
    name: 'Submit',
    component: lazyLoad("Submit")
  },
  {
    path: '/demos',
    name: 'Demos',
    component: lazyLoad("Demos")
  },
  {
    path: '/searchdemos',
    name: 'SearchDemos',
    component: lazyLoad("SearchDemos")
  },
  {
    path: '/submission',
    name: 'Submission',
    component: lazyLoad("Submission")
  },
  // {
  //   path: '/models',
  //   name: 'Models',
  //   component: lazyLoad("Models")
  // },
  {
    path: '/searchmodels',
    name: 'SearchModels',
    component: lazyLoad("SearchModels")
  },
  {
    path: '/contact',
    name: 'Contact',
    component: lazyLoad("Contact")
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: lazyLoad("PrivacyPolicy")
  },
  // {
  //   path: '/admin',
  //   component: lazyLoad("Admin/Base"),
  //   children: [
  //       {
  //         path: '/',
  //         name: 'Login',
  //         component: lazyLoad("Admin/Login")
  //       },
  //       {
  //         path: '/inbox',
  //         name: 'Inbox',
  //         component: lazyLoad("Admin/Inbox")
  //       },
  //     ]
  // },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
